<script setup lang="ts">
const companyName = import.meta.env.VITE_COMPANY_NAME
const companyInn = import.meta.env.VITE_COMPANY_INN
const currentYear = new Date().getFullYear()
const policyUrl = import.meta.env.VITE_POLICY_URL
const personalDataUrl = import.meta.env.VITE_PERSONAL_DATA_URL
const agreementUrl = import.meta.env.VITE_AGREEMENT_URL
</script>

<template>
  <footer class="app-footer container">
    <div class="app-footer__inner">
      <p class="app-footer__copyright" v-if="companyName && companyInn">
        ⓒ {{ currentYear }}  Все права защищены. {{ companyName }}, ИНН {{ companyInn }}
      </p>
      <div class="app-footer__documents">
        <a
          v-if="policyUrl"
          class="app-footer__documents-link"
          :href="policyUrl"
          target="_blank"
        >
          Политика конфиденциальности
        </a>
        <a
          v-if="personalDataUrl"
          class="app-footer__documents-link"
          :href="personalDataUrl"
          target="_blank"
        >
          Согласие на обработку персональных данных
        </a>
        <a
          v-if="agreementUrl"
          class="app-footer__documents-link"
          :href="agreementUrl"
          target="_blank"
        >
          Пользовательское соглашение
        </a>
      </div>
    </div>
  </footer>
</template>

<style lang="scss" scoped>
.app-footer {
  padding-block: 32px;
  color: var(--color-gray-60);
  font-size: 12px;

  @include mobile {
    padding-block: 24px 32px;
  }

  &__inner {
    display: flex;
    row-gap: 16px;
    flex-direction: column;
    margin-inline: auto;
    max-width: 720px;
    text-align: center;
  }

  &__documents {
    display: flex;
    justify-content: space-between;
    gap: 16px;

    @include mobile {
      flex-direction: column;
      align-items: center;
    }

    &-link {
      color: var(--color-gray-60);

      @include hover {
        text-decoration: none;
      }
    }
  }
}
</style>
